/**
 * Disclosure / vendor workflow statuses from the API (snake_case).
 * @param {string} [status]
 * @returns {{ key: string, label: string, badgeClass: string, icon: string }}
 */
export function getDisclosureStatusDisplay(status) {
  const key = String(status || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "_");

  const map = {
    not_started: {
      label: "Not started",
      badgeClass: "bg-secondary",
      borderClass: "border-secondary",
      icon: "bi-circle",
    },
    in_progress: {
      label: "In progress",
      badgeClass: "bg-warning text-dark",
      borderClass: "border-warning",
      icon: "bi-arrow-repeat",
    },
    submitted: {
      label: "Submitted",
      badgeClass: "bg-success",
      borderClass: "border-success",
      icon: "bi-check-circle-fill",
    },
    overdue: {
      label: "Overdue",
      badgeClass: "bg-danger",
      borderClass: "border-danger",
      icon: "bi-exclamation-triangle-fill",
    },
  };

  if (map[key]) {
    return { key, ...map[key] };
  }

  return {
    key,
    label: status ? String(status).replace(/_/g, " ") : "Unknown",
    badgeClass: "bg-light text-dark",
    borderClass: "border-secondary",
    icon: "bi-question-circle",
  };
}
